import { UfinityProduct } from '../models'
import { PaymentMethod, Offer } from 'models'

/**
 * Mapping between Nagra and Ufinity factory
 * @param {Array<Object>} productIdList Raw object commit
 * @returns {UfinityProductMapping}
 */
export const ufinityProductMappingFactory = (productIdList) => {
    return (productIdList || []).reduce((acc, { nagraProductId, productId = [] }) => {
        acc[nagraProductId] = (productId || []).map(({ id }) => id)
        return acc
    }, {})
}

/**
 * Mapping between Nagra and Ufinity factory
 * @param {Array<Object>} productIdList Raw object commit
 * @param {Array<String>} userPaymentMethods List of payment methods for offer filtering
 * @returns {Array<UfinityProduct>}
 */
export const ufinityOffersFactory = (
    productIdList,
    userPaymentMethods = [PaymentMethod.PAYMENT_METHOD_TYPE.PAY_ON_BILL]
) => {
    const products = (productIdList || []).map((ufiProduct = {}) => {
        return new UfinityProduct(ufiProduct)
    })
    // Currency is not provided through the offers but directly from the product
    return products.reduce((acc, product = {}) => {
        let eligibleOffer
        switch (product.paymentMethod) {
            case UfinityProduct.PAYMENT_METHOD.BILL:
                eligibleOffer = userPaymentMethods.includes(
                    PaymentMethod.PAYMENT_METHOD_TYPE.PAY_ON_BILL
                )
                break
            case UfinityProduct.PAYMENT_METHOD.IOS:
                eligibleOffer = userPaymentMethods.includes(
                    PaymentMethod.PAYMENT_METHOD_TYPE.APPSTORE_IAP
                )
                break
            case UfinityProduct.PAYMENT_METHOD.CREDIT_CARD:
                eligibleOffer =
                    userPaymentMethods.includes(PaymentMethod.PAYMENT_METHOD_TYPE.CREDIT_CARD) ||
                    userPaymentMethods.includes(
                        PaymentMethod.PAYMENT_METHOD_TYPE.CREDIT_CARD_USING_SECONDARY_DEVICE
                    )
                break
            case UfinityProduct.PAYMENT_METHOD.BOTH:
                eligibleOffer =
                    userPaymentMethods.includes(PaymentMethod.PAYMENT_METHOD_TYPE.CREDIT_CARD) ||
                    userPaymentMethods.includes(PaymentMethod.PAYMENT_METHOD_TYPE.PAY_ON_BILL) ||
                    userPaymentMethods.includes(
                        PaymentMethod.PAYMENT_METHOD_TYPE.CREDIT_CARD_USING_SECONDARY_DEVICE
                    )

                break
            default:
                eligibleOffer = false
                break
        }

        if (eligibleOffer) {
            const {
                productId,
                productType,
                description,
                purchaseEndTime,
                purchaseStartTime,
                priceFinal,
                rentalPeriod,
            } = product
            acc.push(
                new Offer({
                    id: productId,
                    offerId: productId,
                    offerType: productType,
                    title: description,
                    // rental period seems available only for tvods
                    period: rentalPeriod > 0 ? rentalPeriod : purchaseEndTime - purchaseStartTime,
                    periodUnit: Offer.UNIT.SECOND,
                    price: priceFinal,
                    originalPrice: priceFinal,
                })
            )
        }
        return acc
    }, [])
}

/**
 * @typedef {Object} UfinityProductMapping
 * @property {Array<String>} nagraProductId - list of product IDs
 */
